export default __webpack_public_path__ + "static/media/2.b1c8a8c4.png";